// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { __awaiter, __generator } from "tslib";
/**
 * Convert a Browser Blob object into ArrayBuffer.
 *
 * @export
 * @param {Blob} blob
 * @returns {Promise<ArrayBuffer>}
 */
export function blobToArrayBuffer(blob) {
    return __awaiter(this, void 0, void 0, function () {
        var fileReader;
        return __generator(this, function (_a) {
            fileReader = new FileReader();
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    fileReader.onloadend = function (ev) {
                        resolve(ev.target.result);
                    };
                    fileReader.onerror = reject;
                    fileReader.readAsArrayBuffer(blob);
                })];
        });
    });
}
/**
 * Convert a Browser Blob object into string.
 *
 * @export
 * @param {Blob} blob
 * @returns {Promise<ArrayBuffer>}
 */
export function blobToString(blob) {
    return __awaiter(this, void 0, void 0, function () {
        var fileReader;
        return __generator(this, function (_a) {
            fileReader = new FileReader();
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    fileReader.onloadend = function (ev) {
                        resolve(ev.target.result);
                    };
                    fileReader.onerror = reject;
                    fileReader.readAsText(blob);
                })];
        });
    });
}
export function streamToBuffer() { }
export function streamToBuffer2() { }
export function readStreamToLocalFile() { }
export var fsStat = function stat() { };
//# sourceMappingURL=utils.browser.js.map